import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

function StockReport() {
  const [data, setData] = useState([]); // Store data from API
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [fromDate, setFromDate] = useState(""); // From date state
  const [toDate, setToDate] = useState(""); // To date state

  // Fetch data from the API when the component mounts or when the dates change
  const fetchData = async () => {
    if (!toDate) {
      alert("Please select both 'From' and 'To' dates.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Construct the API URL with the selected date range
      const response = await axios.get(
        `https://webcore.hunzagroupofindustries.com.pk/api/LabAnalysis?tDate=${toDate}&CompId=2`
      );
      setData(response.data); // Set the fetched data in state
    } catch (err) {
      setError("Failed to fetch data: " + err.message);
    } finally {
      setLoading(false); // Set loading state to false once the request completes
    }
  };

  // Format number with two decimal places for better readability
  const formatNumber = (num) => (num ? num.toFixed(2) : "0.00");

  // Define the column headers and their corresponding API fields
  const products = [
    { name: "Crushing", columns: ["CrushingOnDate", "CrushingToDate"] },
    {
      name: "Mill Extraction",
      columns: ["MillExtractionOD", "MillExtractionTD"],
    },
    {
      name: "Mixed Juice",
      columns: ["MixedJuicePCaneOD", "MixedJuicePCaneTD"],
    },
    { name: "Imbibition", columns: ["ImbibitionPCaneOD", "ImbibitionPCaneTD"] },
    { name: "POLPCane", columns: ["POLPCaneOD", "POLPCaneTD"] },

    // { name: "Molasses Produced", columns: ["MolassesProducedOD", "MolassesProducedTD"] },

    // { name: "Fiber PCane", columns: ["FiberPCaneOD", "FiberPCaneTD"] },
    // { name: "Estimate Bagasse Saved", columns: ["EstimateBagasseSavedOD", "EstimateBagasseSavedTD"] },
    // { name: "PowerHouse Load", columns: ["PowerHouseLoadOD", "PowerHouseLoadTD"] },
    // { name: "Boiler Load", columns: ["BoilerLoadOD", "BoilerLoadTD"] },
  ];
  const p2 = [
    {
      name: "Losses in Molasses",
      columns: ["LossesInMolassesOD", "LossesInMolassesTD"],
    },
    {
      name: "Losses in Bagasse",
      columns: ["LossesInBagasseOD", "LossesInBagasseTD"],
    },
    { name: "Losses in Mud", columns: ["LossesInMudOD", "LossesInMudTD"] },
    // { name: "UDLosses", columns: ["UDLossesOD", "UDLossesTD"] },
    { name: "Recovery %", columns: ["RecOnDate", "RecToDate"] },
    { name: "Mud POL", columns: ["MudPOLOD", "MudPOLTD"] },
    { name: "Bagasse POL", columns: ["BagassePOLOD", "BagassePOLTD"] },
  ];
  const molasses = [
    {
      name: "Molasses Purity",
      columns: ["MolassesPurityOD", "MolassesPurityTD"],
    },
    {
      name: "Molasses % Cane",
      columns: ["MolassesPCaneOD", "MolassesPCaneTD"],
    },
  ];
  const bagasse = [
    {
      name: "Moisture in Bagasse",
      columns: ["MoistureInBagasseOD", "MoistureInBagasseTD"],
    },
  ];
  const CrusherJPurity = [
    { name: "Shift A", columns: ["CrusherJPurityA"] },
    { name: "Shift B", columns: ["CrusherJPurityB"] },
    { name: "Shift C", columns: ["CrusherJPurityC"] },
  ];

  return (
    <div>
      <h3 className="text-center mb-4">Lab Analysis </h3>

      {/* Date Selection Input */}

      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <label htmlFor="toDate" className="form-label">
            To Date:
          </label>
          <input
            type="date"
            id="toDate"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Show Data"}
          </button>
        </div>
      </div>

      {/* Error Handling */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Table with Data */}
      {!loading && data.length > 0 && (
        <div className="row">
          <div className="col-md-4 offset-md-4">
            <div className="table-responsive mt-3">
              <table className="table table-bordered table-hover table-sm">
                <thead className="table-dark">
                  <tr>
                    <th>Particular</th>
                    <th className="text-end">On Date</th>
                    <th className="text-end">To Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <strong>Mill Performce</strong>
                  </tr>
                  {products.map((product, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{product.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][product.columns[0]])}
                      </td>

                      {/* To Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][product.columns[1]])}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    {" "}
                    <strong>Losses</strong>
                  </tr>
                  {p2.map((p2, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{p2.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][p2.columns[0]])}
                      </td>

                      {/* To Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][p2.columns[1]])}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <strong>Molasses</strong>
                  </tr>
                  {molasses.map((molasses, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{molasses.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][molasses.columns[0]])}
                      </td>

                      {/* To Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][molasses.columns[1]])}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <strong>Bagasse</strong>{" "}
                  </tr>
                  {bagasse.map((bagasse, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{bagasse.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][bagasse.columns[0]])}
                      </td>

                      {/* To Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][bagasse.columns[1]])}
                      </td>
                    </tr>
                  ))}
                   <tr>
                    <strong>CrusherJPurity</strong>{" "}
                  </tr>
                  {CrusherJPurity.map((CrusherJPurity, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{CrusherJPurity.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][CrusherJPurity.columns[0]])}
                      </td>

                      {/* To Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][CrusherJPurity.columns[1]])}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Loading Indicator */}
      {loading && <div className="text-center">Loading...</div>}

      {/* No Data Available */}
      {!loading && data.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          No data available
        </div>
      )}
    </div>
  );
}

export default StockReport;
